var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card m-1"},[_c('div',{staticClass:"card-body maadi-dark-card"},_vm._l((_vm.latestMembers),function(member){return _c('div',{key:member.id,staticClass:"m-2 pb-3 pt-3 d-flex",staticStyle:{"border":"1px solid #3E597A"}},[_c('single-organization-result-v2',{attrs:{"organization":member}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-874700e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/membership/LatestMembers.vue
// module id = null
// module chunks = 